import { images } from './images';

export const projects = [

  {
    title: "Emojify Movie Picker",
    subtitle: "Express.js,Server-side APIs",
    description:
      "Application to suggest movie based on mood represented by emojis",

    image: images.image6,
    link: "https://samhiga.github.io/emojify/",
  },

  {
    title: "Password Generator",
    subtitle: "HTML, CSS",
    description:
      "This app allows users to randomly generate a password that meets a strict criteria ",
    image: images.image3,
    link: "https://sabeen44.github.io/unique-password-generator/",
  },

  {
    title: "Weather Dash",
    subtitle: "Javascript, Web API",
    description:
      "User can search for a city for current and 5-day weather forecast",
    image: images.image5,
    link: "https://sabeen44.github.io/Weather-Dash/",
  },

  {
    title: "Little Lemon",
    subtitle: "React, TailwindCSS",
    description: "a modern responsive front end app that allows users to reserve a table at a restaurant.  ",
    image: images.image4,
    link: "https://sabeen44.github.io/Fun-Coding-Quiz/",
  },

  // {
  //   title: "Epic Todo App",
  //   subtitle: "React Hooks",
  //   description:
  //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
  //   image: "./project-4.gif",
  //   link: "https://pythonbootcamp.com",
  // },
];

